import React, { useState } from 'react';
import Seo from './Seo';
import '../WellnassFeatured.css';
import '../RedesignHome.css';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

import wordpress from '../images/d-5.png';
import d1 from '../images/d-1.png';
import d2 from '../images/d-2.png';
import d3 from '../images/d-3.png';
import d4 from '../images/d-4.png';
import twitter from '../images/twitter.png';
import linkedin from '../images/linkedin.png';

export default function IndexComponent() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [messageConfirmation, setMessageConfirmation] = useState("");
  const [messageError, setMessageError] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setMessageError("");
    setMessageConfirmation("");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessageError(t("email_invalid"));
      return;
    }
    try {
      const formData = new FormData();
      formData.append('email', email);
      const url = `${process.env.REACT_APP_API_URL}/subscribeNewsLetter`;
      const response = await axios.post(url, formData, { headers: { 'content-type': 'multipart/form-data' } });
      if (response?.data?.data?.returnCode === 'OK') {
        setMessageConfirmation(t("newsletter_success"));
        setEmail("");
      } else {
        setMessageError(t("subscription_failed"));
      }
    } catch (err) {
      setMessageError(t("subscription_failed"));
    }
  };

  const stack = [
    { img: d1, name: 'Java' },
    { img: d3, name: 'Spring' },
    { img: d4, name: 'Angular' },
    { img: d2, name: 'React' },
    { img: wordpress, name: 'WordPress' },
  ];

  const services = [
    { icon: '🧭', title: t('consulting_h5'), desc: t('consulting_p2') },
    { icon: '⚙️', title: t('agile_h5'), desc: t('agile_p2') },
    { icon: '🎓', title: t('training_h5'), desc: t('training_p2') },
  ];

  return (
    <div className="content-index rd_home">
      <Seo />

      {/* ---------------- HERO ---------------- */}
      <section className="rd_hero">
        <div className="rd_wrap rd_hero_grid">
          <div>
            <span className="rd_eyebrow">{t('hero_eyebrow')}</span>
            <h1>{t('hero_title')}</h1>
            <p className="rd_hero_sub">{t('hero_sub')}</p>
            <div className="rd_cta_row">
              <a className="rd_btn rd_btn_primary" href="/contactUs">{t('hero_cta1')} <span aria-hidden="true">→</span></a>
              <a className="rd_btn rd_btn_ghost" href="#realisations">{t('hero_cta2')}</a>
            </div>
            <div className="rd_hero_stats">
              <div><div className="n">10+</div><div className="l">{t('years_of_excellence_h5')}</div></div>
              <div><div className="n">20+</div><div className="l">{t('projects_delivered_h5')}</div></div>
              <div><div className="n">5</div><div className="l">{t('hero_stat_tech')}</div></div>
            </div>
          </div>

          <div className="rd_code" aria-hidden="true">
            <div className="rd_code_bar">
              <span className="rd_dot r"></span><span className="rd_dot y"></span><span className="rd_dot g"></span>
              <span className="rd_code_file">SolutionService.java</span>
            </div>
            <pre>
<span className="c">// Du besoin métier à la mise en production</span>{'\n'}
<span className="k">@Service</span>{'\n'}
<span className="k">public class</span> <span className="t">SolutionService</span> {'{'}{'\n'}
{'  '}<span className="k">public</span> <span className="t">Projet</span> <span className="f">livrer</span>(<span className="t">Besoin</span> besoin) {'{'}{'\n'}
{'    '}<span className="k">return</span> pipeline{'\n'}
{'      '}.<span className="f">analyser</span>(besoin){'\n'}
{'      '}.<span className="f">concevoir</span>(<span className="s">"architecture"</span>){'\n'}
{'      '}.<span className="f">developper</span>(<span className="s">"Spring + React"</span>){'\n'}
{'      '}.<span className="f">deployer</span>();{'\n'}
{'  '}{'}'}{'\n'}
{'}'}
            </pre>
          </div>
        </div>
      </section>

      {/* ---------------- EXPERTISE / STACK ---------------- */}
      <section className="rd_section">
        <div className="rd_wrap rd_center rd_head">
          <span className="rd_eyebrow">{t('expertise_h2')}</span>
          <h2 className="rd_h2">{t('expertise_p')}</h2>
        </div>
        <div className="rd_wrap">
          <div className="rd_stack">
            {stack.map((s) => (
              <div className="rd_chip" key={s.name}>
                <img src={s.img} alt={s.name} /> {s.name}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- SERVICES ---------------- */}
      <section className="rd_section alt">
        <div className="rd_wrap rd_center rd_head">
          <span className="rd_eyebrow">Services</span>
          <h2 className="rd_h2">{t('services_h2')}</h2>
          <p className="rd_lead">{t('services_p')}</p>
        </div>
        <div className="rd_wrap">
          <div className="rd_cards">
            {services.map((s) => (
              <div className="rd_card" key={s.title}>
                <div className="rd_ic">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- ABOUT ---------------- */}
      <section className="rd_section rd_about">
        <div className="rd_wrap rd_about_grid">
          <div>
            <span className="rd_eyebrow">{t('who_we_are_h2')}</span>
            <h2 className="rd_h2">{t('about_headline')}</h2>
          </div>
          <div className="rd_about_card">
            <p className="rd_lead" style={{ color: '#c7cdd6' }}>{t('who_we_are_p')}</p>
          </div>
        </div>
      </section>

      {/* ---------------- RÉALISATIONS ---------------- */}
      <div id="realisations" className="rd_real_head">
        <div className="rd_wrap rd_center">
          <span className="rd_eyebrow">{t('realisations_h2')}</span>
          <h2 className="rd_h2">{t('realisations_p')}</h2>
        </div>
      </div>

      <section className="wf_section" style={{ paddingTop: 40 }}>
        <div className="wf_inner">
          <div className="wf_text">
            <span className="wf_label">{t('featured_label')}</span>
            <h2 className="wf_title">{t('wellnass_title')}</h2>
            <p className="wf_desc">{t('wellnass_desc')}</p>
            <div className="wf_tags">
              <span>Spring Boot</span><span>Microservices</span><span>React</span>
              <span>PostgreSQL</span><span>Kafka</span><span>Docker</span>
            </div>
            <div className="wf_actions">
              <a className="wf_cta" href="https://wellnass.ybtechnicalservices.com" target="_blank" rel="noopener noreferrer">
                {t('wellnass_cta')} <span aria-hidden="true">→</span>
              </a>
              <span className="wf_live"><span className="wf_dot"></span>{t('featured_live')}</span>
            </div>
          </div>
          <div className="wf_visual">
            <div className="wf_browser">
              <div className="wf_bar">
                <span className="wf_d wf_r"></span><span className="wf_d wf_y"></span><span className="wf_d wf_g"></span>
                <span className="wf_url">wellnass.ybtechnicalservices.com</span>
              </div>
              <a href="https://wellnass.ybtechnicalservices.com" target="_blank" rel="noopener noreferrer">
                <img src={process.env.PUBLIC_URL + '/images/wellnass-showcase.png'} alt="Wellnass — plateforme de coaching bien-être au Maroc" loading="lazy" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- STATS ---------------- */}
      <section className="rd_section">
        <div className="rd_wrap">
          <div className="rd_stats">
            <div className="rd_stat"><div className="n">10+</div><div className="l">{t('years_of_excellence_h5')}</div></div>
            <div className="rd_stat"><div className="n">20+</div><div className="l">{t('projects_delivered_h5')}</div></div>
            <div className="rd_stat"><div className="n">5+</div><div className="l">{t('satisfied_customers_h5')}</div></div>
            <div className="rd_stat"><div className="n">100%</div><div className="l">{t('commitment_h5')}</div></div>
          </div>
        </div>
      </section>

      {/* ---------------- FOOTER / CONTACT ---------------- */}
      <footer className="rd_footer">
        <div className="rd_wrap rd_foot_grid">
          <div>
            <h5>YB Technical Services</h5>
            <div className="rd_foot_row">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              <span>Ibnou Habous, Maârif Extension — Casablanca, Maroc</span>
            </div>
            <div className="rd_foot_row">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              <a href="tel:+212701303164">+212 701 303 164</a>
            </div>
            <div className="rd_foot_row">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 6L2 7"/></svg>
              <a href="mailto:contact@ybtechnicalservices.com">contact@ybtechnicalservices.com</a>
            </div>
          </div>

          <div>
            <h5>{t('footer_info')}</h5>
            <p className="rd_news" style={{ margin: 0 }}>{t('custom_solutions')}</p>
          </div>

          <div>
            <h5>Newsletter</h5>
            <div className="rd_news">
              <p>{t('footer_news_desc')}</p>
              <form onSubmit={handleSubscribe}>
                <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t('subscribe_email_placeholder')} />
                <button type="submit">{t('subscribe_button')}</button>
              </form>
              {messageConfirmation && <p className="rd_ok">{messageConfirmation}</p>}
              {messageError && <p className="rd_err">{messageError}</p>}
              <div className="rd_social">
                <a href="https://x.com/ybtechservices" target="_blank" rel="noopener noreferrer"><img src={twitter} alt="X / Twitter" /></a>
                <a href="https://www.linkedin.com/company/ybtechservices/" target="_blank" rel="noopener noreferrer"><img src={linkedin} alt="LinkedIn" /></a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
